<template>
  <div class="CGInventory">
    <div>
      <div class="icon"><img src="../../../../../../static/images/icon1.png" alt=""></div>
      <div class="name">盘点中，请稍后</div>
    </div>
    <mqttws :topic="topic" :msg="msg" :isConnect="isConnect" :topic2="topic2" :msg2="msg2" :isSend="isSend" ref="mqttws" @getMessage="getMessage"></mqttws>
    <currtime :isShowInfo="false"></currtime>
  </div>
</template>

<script>
import currtime from '../../../../../assets/currTime'
import mqttws from '../../../../../assets/mqttws'
import { checkData } from '../../../../../../static/js/utils/util.js'
import { adminApi } from '../../../../../../static/js/api.js'
import * as config from '../../../../../../static/js/config.js';
import { localUserInfo,storage } from '../../../../../../static/js/utils/utility.js'
export default {
  name: 'CGInventory',
  data () {
    return {
      // user_id:'',
      boxId:'',

      topic:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol/response',
      // topic:'/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol',
      msg:'',
      isConnect:true,//是否默认订阅

      topic2:'/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol',
      msg2:'',
      isSend:true,

      overtime:30,//超时
      overtimeStatus:'',//超时状态
    }
  },
  mounted(){

  },
  created(){
    var that = this
    this.boxId = this.$route.query.boxId
    var boxId =this.$route.query.boxId
    // if(boxId <= 9){
    //   boxId = '0'+boxId
    // }
    var msg = 'a5551505160101010000000101d6080001'+boxId;
    var num = checkData(msg)
    msg = msg+num
    that.msg2 = msg
    // this.user_id = localUserInfo.getItem().user_id

    that.overTime(that.overtime)
  },
  components:{
    mqttws,
    currtime
  },
  methods:{
    //超时
    overTime(wait){
      var that = this;
      var _wait = wait;
      if(wait == 0) {
        wait = _wait;
        clearTimeout(that.overtimeStatus)
        that.$router.go(0)
      } else {
        this.overtime=wait
        wait--;
        that.overtimeStatus = setTimeout(function() {
          that.overTime(wait);
        },1000);
      }
    },
    //盘点
    async borrowReturn(data){
      var that = this;
      var dataObj = {
        'location_id': that.boxId,
        // 'user_id': that.user_id,
        'cabinet_id': config.deviceId,
        'type': '2',
        'data': data,
        'way':'usual',
      }
      var res = await adminApi.borrowReturn(dataObj);
      if(res.meta.code == 200){
        storage.sessionSetItem('boxInventory',res.body)
        // that.$refs.mqttws.disconnect()
        that.$router.push({
          path:'/toolCabinet/CCloseDoor',
          query:{
            boxId:that.boxId,
            type:'2',//1借用2归还3管理员入库（自定义）
          }
        })
      }else{
        // that.$refs.mqttws.disconnect()
        that.$message.error(res.meta.message)
        that.$router.push({
          path:'/toolCabinet/CLogin',
        })
      }
    },
    //接收mqtt信息
    getMessage(data){
      var that = this;
      if(data){
        var str = data.substring(2,data.length-2);//截取字符串的第二到倒数第二的数据
        var str2 = data.substring(2,data.length);
        var num = checkData(str)
        var bbc = data.substr(data.length-2)
        // var id = str.substring(str.length-4,str.length)
        var type = str.substring(26,30)
        // if(lastTwo == 55 && num == bbc){
        that.overtime=30
        if( type == 'd608'){
          var lastTwo = str.substring(str.length-2,str.length)
          if(num == bbc && lastTwo == '01'){
            topic = '/'+ config.clientPort +'/report/'+ config.serverPort +'/environment/protocol'
            that.$refs.mqttws.onConnect(topic)
          }else{
            var boxId = that.boxId
            // if(boxId <= 9){
            //   boxId = '0'+boxId
            // }
            var topic = '/'+ config.serverPort +'/down/'+ config.clientPort +'/control/protocol'
            var msg = 'a5551505160101010000000101d6080001'+boxId
            var num2 = checkData(msg)
            msg = msg+num2
            // console.log('topic',topic)
            // console.log('msg',msg)
            that.$refs.mqttws.send(topic,msg)
          }
        }else if(type == 'df10'){
          var lastTwo = str.substring(36,38)
          if(lastTwo == '01'){
            clearTimeout(that.overtimeStatus)
            that.borrowReturn(str2)
          }else{
            
          }
          
        }
      }
    },
  },
  watch :{

  },
}
</script>

<style lang="less">
.CGInventory{
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  // background: url('../../../../../../static/images/bg.jpg') center no-repeat;
  // background-size: cover;
  .icon{
    width: 1.67rem;
    height: 1.67rem;
    margin: 0 auto;
    img{width: 100%;}
  }
  .name{
    font-size: 0.5rem;
    margin: 0.8rem 0 0.27rem;
    span{color:#fff;}
  }
  .currTime{
    position: absolute;
    right: 0.2rem;
    top: 0.2rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CToolCabinet/page/CEmployee/CGiveBack/CGInventory.vue